var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOrganic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7752 9.02403C16.5723 10.8066 14.7407 10.496 12.6545 12.2007C10.0616 14.3195 10.6503 19.2877 10.8499 20.4149C11.1215 19.3949 11.6946 17.6743 12.7264 16.3133C13.9134 14.7476 15.3902 14.0244 15.9589 13.6671C16.5277 13.3099 16.9852 12.7874 16.9852 12.7874C16.9852 12.7874 16.6343 13.4868 15.7375 14.0797C14.9545 14.5973 13.6295 15.1963 12.4566 17.3547C11.7961 18.57 11.4123 19.8201 11.2523 20.5587C11.6206 20.291 12.063 19.9988 12.7466 19.4996C15.8359 17.2438 18.4849 17.8371 19.7063 13.4567C20.3112 11.2877 19.7947 8.186 19.7947 8.186C19.7947 8.186 19.5144 8.42578 18.7752 9.02403Z",
    fill: "#AADB1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49354 7.89514C7.28464 9.87842 6.20334 10.6229 6.01394 12.5094C5.77864 14.8542 8.59131 17.071 9.26274 17.5416C8.88323 16.8933 8.30125 15.7432 8.13263 14.5489C7.93867 13.1749 8.3176 12.0834 8.42362 11.6233C8.52965 11.1632 8.49591 10.6744 8.49591 10.6744C8.49591 10.6744 8.67305 11.2 8.52078 11.9403C8.38789 12.5868 8.02263 13.5408 8.5237 15.2071C8.80582 16.1452 9.24522 16.9649 9.53844 17.4161C9.58876 17.0999 9.66408 16.7347 9.7561 16.1465C10.1725 13.4881 11.8094 12.4841 10.2077 9.67306C9.41466 8.28123 7.58357 6.97055 7.58357 6.97055C7.58357 6.97055 7.56372 7.22944 7.49354 7.89514Z",
    fill: "#AADB1E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    stroke: "#AADB1E",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganic);
export default __webpack_public_path__ + "static/media/icon-organic.d4bb44336b755379418f647bdeb54e98.svg";
export { ForwardRef as ReactComponent };